const Footer = () => {
  return (
    <footer className="d-footer">
      <div className="row align-items-center justify-content-center justify-content-sm-between">
        <div className="col-auto">
          <p className="mb-0">
            کلیه حقوق برای{" "}
            <span className="text-primary-600 fw-semibold">آکسون</span> محفوظ
            است.
          </p>
        </div>
        {/* <div className="col-auto">
          <p className="mb-0">
            ایجاد شده توسط{" "}
            <a
              href="https://hamzehazizzadeh.ir"
              target="_blank"
              rel="noreferrer"
              className="text-primary-600 fw-bold"
            >
              حمزه عزیززاده
            </a>
          </p>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
